import React from 'react'
class SearchResult extends React.Component {
  render () {
    return <span className={'infra-global-search-result-span'} dir='ltr' onClick={() => this.props.onClick()}>
      <div className={'infra-global-search-result-picture'}>
        <img src={this.props.img} />
      </div>
      <div className={'infra-global-search-result-texts'}>
        <div className={'infra-global-search-result-title'}>
          {this.props.title}
        </div>
        <div className={'infra-global-search-result-description'}>
          {this.props.description}
        </div>
      </div>
    </span>
  }
}

export default SearchResult

SearchResult.propTypes = {
  onClick: React.PropTypes.func,
  description: React.PropTypes.string,
  img: React.PropTypes.string,
  title: React.PropTypes.string
}




// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/SearchBox/SearchResult.js